import { type ElementData } from './element';
import { sectionElementType } from './elements/section';
import { type ElementClipboardData } from './ui';

const emptyAdf = JSON.stringify({
  type: 'doc',
  version: 1,
  content: [{ type: 'paragraph', content: [{ type: 'text', text: ' ' }] }],
});

/**
 * Strips properties from an element that do not need to be included in the copy payload.
 */
export function serializeCopyPayload(
  element: ElementData,
  retainContent = true
): ElementClipboardData {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id, lockedByUser, ...payload } = element;

  if (!retainContent && 'text' in payload) {
    return {
      ...payload,
      text: emptyAdf,
    } as ElementClipboardData;
  }

  if (!retainContent && element.type === sectionElementType) {
    return {
      ...payload,
      title: '',
    } as ElementClipboardData;
  }

  return payload;
}
